export default[
    //选择银行卡
    {
        path:'/finza/card',
        name:'cardlist',
        meta:{
            title:'Banco'
        },
        component:()=>import('@/finzaapp/views/card/list/index')
    },
    //添加银行卡
    {
        path:'/finza/card/add',
        name:'bindcard',
        meta:{
            title:'Añadir una tarjeta bancaria'
        },
        component:()=>import('@/finzaapp/views/card/add/index')
    },
    //订单页面
    {
        path:'/finza/order',
        name:'order',
        meta:{
            title:'Detalles del pedido'
        },
        component:()=>import('@/finzaapp/views/order/index/index')
    },
    //展期订单
    {
        path:'/finza/order/delayed/:orderId',
        name:'orderDelayed',
        meta:{
            title:'Extensión de pago'
        },
        component:()=>import('@/finzaapp/views/order/delayed/index')
    },
    //历史订单列表
    {
        path:'/finza/order/history',
        name:'orderhistory',
        meta:{
            title:'Pedidos históricos'
        },
        component:()=>import('@/finzaapp/views/order/history/index')
    },
    //历史订单详情
    {
        path:'/finza/order/history/details/:orderId',
        name:'orderdetails',
        meta:{
            title:'Detalles del pedido'
        },
        component:()=>import('@/finzaapp/views/order/details/index')
    },
    //完成订单
    {
        path:'/finza/order/detail/:orderId/:loanTenureType/:curInstallment',
        name:'detail',
        meta:{
            title:'Detalles del pedido'
        },
        component:()=>import('@/finzaapp/views/order/successes/index')
    },
    //android-客服
    {
        path:'/finza/customer/index',
        name:'customerAndroid',
        meta:{
            title:'Comentarios sobre el servicio'
        },
        component:()=>import('@/finzaapp/views/customer/android/index')
    },
    //IOS-客服
    {
        path:'/finza/customer/ios',
        name:'customerIos',
        meta:{
            title:'Comentarios sobre el servicio'
        },
        component:()=>import('@/finzaapp/views/customer/ios/index')
    },
    //借款协议
    {
        path:'/finza/agreement',
        name:'agreementIndex',
        meta:{
            title:'Acuerdo de Préstamo Personal'
        },
        component:()=>import('@/finzaapp/views/agreement/index/index.vue')
    },
    //FAQ常见问题
    {
        path:'/finza/faq',
        name:'faqIndex',
        meta:{
            title:'FAQ'
        },
        component:()=>import('@/finzaapp/views/faq/index/index.vue')
    },
]



// WEBPACK FOOTER //
// ./src/finzaapp/router/router.js